import { render } from "./App.vue?vue&type=template&id=2c4b4dc9"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/efakturastat.dev.oneit.rs/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c4b4dc9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c4b4dc9', __exports__)) {
    console.log('reload')
    api.reload('2c4b4dc9', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=2c4b4dc9", () => {
    console.log('re-render')
    api.rerender('2c4b4dc9', render)
  })

}


export default __exports__